import { render } from "./TicketsActionMenu.vue?vue&type=template&id=499ba51e"
import script from "./TicketsActionMenu.vue?vue&type=script&lang=js"
export * from "./TicketsActionMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__